import { apiClient } from '../utils/apiClient';

const businessService = {
  createBusinessIdea: async (ideaData) => {
    try {
      const response = await apiClient.businessIdeas.create(ideaData);

      if (!response?.data?.analysis || !response?.data?.businessIdea) {
        console.error('Missing required data:', {
          hasAnalysis: !!response?.data?.analysis,
          hasBusinessIdea: !!response?.data?.businessIdea
        });
        throw new Error('Invalid API response structure');
      }

      return response?.data;
    } catch (error) {
      console.error('=== Data Flow Error ===', error);
      throw error;
    }
  },
  generateFieldSuggestion: async (suggestionData) => {
    try {
      const result = await apiClient.businessIdeas.generateSuggestion(suggestionData);
      return result;
    } catch (error) {
      console.error('Error generating suggestion:', error);
      throw error;
    }
  },

  getBusinessIdeaAnalysis: async (businessId) => {
    try {
      const response = await apiClient.businessIdeas.getAnalysis(businessId);

      const processedData = {
        businessIdea: response.data.businessIdea,
        analysis: response.data.analysis
      };

      return processedData;
    } catch (error) {
      console.error('=== Data Flow Error ===', error);
      throw error;
    }
  }
};

export default businessService;
